import { PassThrough } from '@primevue/core'
import { PrimeVuePTOptions } from 'primevue'

// @unocss-include
export default {
  confirmdialog: {
    /*
     * The dialog sizes itself to its content, so a confirmation with more than one line of explanation
     * stretches the full viewport width. Cap it and let the message wrap instead. Inline styles rather
     * than utilities: UnoCSS does not pick up classes added to this config file reliably.
     */
    root: {
      style: {
        'max-width': '36rem',
        width: 'calc(100vw - 2rem)',
      },
    },
    pcRejectButton: {
      root: {
        class: 'p-button-outlined',
      },
    },
  },
  message: {
    icon: {
      class: 'm-x-1',
    },
  },
  card: {
    caption: {
      class: 'gap-0',
    },
    title: {
      class: '!text-lg',
    },
    subtitle: {
      class: '!text-sm',
    },
  },
  step: {
    root: {
      style: {
        'margin-top': '-1rem',
      },
    },
    header: {
      style: {
        'margin-top': '1rem',
        'flex-direction': 'column',
        'row-gap': '0',
      },
    },
  },
  button: {
    /*
     * Filled/outlined buttons keep the subtle shadow; `text`/`link` variants
     * must stay flat — a shadow on a transparent button reads as a stray box.
     */
    root: ({ props }) => ({
      class: props.text || props.link ? undefined : '!shadow-sm',
    }),
  },
  selectButton: {
    root: {
      class: 'rounded-full',
    },
  },
  tab: {
    root: {
      style: {
        'font-family': '"Montserrat Variable", sans-serif',
      },
    },
  },
} as PassThrough<PrimeVuePTOptions>